/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { css, jsx } from '@compiled/react';

const arcStrokeStyles = css({
	strokeWidth: 133.5,
	transition: 'stroke-width 0.6s ease-out',
});

/**
 * __Arc__
 *
 * An arc glyph component with animated stroke width.
 *
 */
export const Arc = () => (
	<svg
		width="598"
		height="598"
		viewBox="0 0 597.838 598.187"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<mask id="arc-mask">
				<rect x="0" y="0" width="597.838" height="598.187" fill="white" />
				<circle
					cx="0"
					cy="598.186"
					r="425.25"
					stroke="black"
					fill="none"
					data-arc-stroke
					css={arcStrokeStyles}
				/>
			</mask>
		</defs>
		<path
			d="M0.18032 105.931C0.18032 47.45 47.5787 0.052 106.054 0L597.838 0.026V492.386C597.838 550.716 550.568 598.001 492.299 598.001H491.99L0 598.186L0.18032 105.931Z"
			fill="currentColor"
			mask="url(#arc-mask)"
		/>
	</svg>
);
